import React from 'react';
import {PencilIcon, TrashIcon} from "@heroicons/react/solid";
import Dropdown, {DropdownItem} from "components/Dropdown";
import {ExhibitType} from "types/ExhibitType";
import {useNavigate} from "react-router-dom";
import {useAuth} from "context/AuthContext";

// Types ----

type ExhibitTypeContextMenuProps = {
  exhibitType: ExhibitType
  onDeleteExhibitType: () => void
  editDisabled?: boolean
  deleteDisabled?: boolean
  position?: 'left' | 'right'
}

// Component ----

function ExhibitTypeContextMenu({exhibitType, onDeleteExhibitType, editDisabled, deleteDisabled, position = 'right'}: ExhibitTypeContextMenuProps) {
  const navigate = useNavigate();
  const auth = useAuth();

  function editExhibitType() {
    void navigate(`/exhibit-types/${exhibitType.id}/edit`)
  }

  return (
    <Dropdown position={position}>
      {auth.can('exhibit-types:write') &&
        <DropdownItem name="Edit" icon={PencilIcon} onClick={editExhibitType} disabled={!!editDisabled}/>
      }

      {auth.can('exhibit-types:write') &&
        <DropdownItem name="Delete" icon={TrashIcon} onClick={onDeleteExhibitType} disabled={!!deleteDisabled}/>
      }
    </Dropdown>
  );
}

export default ExhibitTypeContextMenu;